/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CardOwnerSelect/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function CardOwnerSelect({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/CreditCardCapture/Ready/Content/CardOwnerSelect"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let creditCardCaptureResponsiblePersonValueData = fromData.useDataValue({ viewPath,
context: 'credit_card_capture',
path: 'responsible_person',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(creditCardCaptureResponsiblePersonValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}